<template>
  <div>
    <container :navWidth="80*4+44" detailWidth="380">
      <template v-slot:nav="{height}">
        <dialog-page-nav
            :height="height"
            :cats.sync="cats"
            :selectChat.sync="chat"
        />
      </template>
      <template v-slot:content="{height}">
        <dialog-page-chat
            :height="height"
            :cats="cats"
            :chat="chat"
            @close="chat=null"
        />
      </template>
      <template v-slot:detail="{height}">
        <dialog-page-chat-detail
          :cats="cats"
          :chat="chat"
        />
        {{height}}
      </template>
    </container>
  </div>
</template>

<script>
import Container from "../../../componentsV2/base/Container.vue";
import DialogPageNav from "./DialogPageNav.vue";
import DialogPageChat from "./DialogPageChat.vue";
import DialogPageChatDetail from "./DialogPageChatDetail.vue";

export default {
  components: {DialogPageChatDetail, DialogPageChat, DialogPageNav, Container},
  data: () => ({
    cats:[],
    chat:null,
  }),
  mounted() {
  },
  methods:{

  }
}
</script>